// 注意: 出码引擎注入的临时变量默认都以 "__$$" 开头，禁止在搭建的代码中直接访问。
// 例外：react 框架的导出名和各种组件名除外。
import React from "react";
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';


import { Container } from "@ifeng-fe/lowcode_basic/src/components/layout/Container/index.tsx";

import { PageNav_1 } from "@ifeng-fe/lowcode_basic/src/components/nav/PageNav_1/index.tsx";

import { LayoutComponent } from "@ifeng-fe/lowcode_basic/src/components/layout/LayoutComponent/index.tsx";

import { Row } from "@ifeng-fe/lowcode_basic/src/components/layout/Row/index.tsx";

import { Col } from "@ifeng-fe/lowcode_basic/src/components/layout/Col/index.tsx";

import { Title } from "@ifeng-fe/lowcode_basic/src/components/popular/Title/index.tsx";

import { NewsList_1 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_1/index.tsx";

import { Swiper_1 } from "@ifeng-fe/lowcode_basic/src/components/Swiper/Swiper_1/index.tsx";

import { VideoList_1 } from "@ifeng-fe/lowcode_basic/src/components/video/VideoList_1/index.tsx";

import { NewsList_7 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_7/index.tsx";

import { NewsList_12 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_12/index.tsx";

import { NewsList_5 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_5/index.tsx";

import { Swiper_finance } from "@ifeng-fe/lowcode_business/src/components/swiper/Swiper_finance/index.tsx";

import { Image_Tabs } from "@ifeng-fe/lowcode_business/src/components/images/Image_Tabs/index.tsx";

import { NewsList_2 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_2/index.tsx";

import { Support } from "@ifeng-fe/lowcode_basic/src/components/popular/Support/index.tsx";

import { Comment } from "@ifeng-fe/lowcode_basic/src/components/popular/Comment/index.tsx";

import { Footer } from "@ifeng-fe/lowcode_basic/src/components/popular/Footer/index.tsx";

import utils from "../../utils";

import "./index.css";

class Layout$$Page extends React.Component {
  _context = this;

  constructor(props, context) {
    super(props);

    this.utils = utils;

    this.state = {};
  }

  $ = () => null;

  $$ = () => [];

  componentDidMount() {}

  render() {
    const __$$context = this._context || this;
    const { state } = __$$context;
    return (
      <div>
        <Container width={1000} isCenter={true} $isHide={false}>
          <PageNav_1
            navChip={{
              $data: true,
              id: "261067",
              type: "struct",
              title: "导航内容",
              default: { type: "struct", id: "260274" },
              uuid: "a923c58a",
            }}
            nodeId="node_ocl75lh7p81"
          />
        </Container>
        <Container
          isCenter={true}
          $isHide={false}
          style={{
            backgroundImage:
              "url(https://x0.ifengimg.com/ucms/2025_42/C0ED7C3550E4C3C2E452D0622193E7F1F65B48ED_size517_w1920_h815.jpg)",
            paddingTop: "300px",
            backgroundPositionX: "center",
            backgroundRepeat: "no-repeat",
            minWidth: "1000px",
          }}
          nodeId="node_ocl7442mzl1"
          hoverStyle=""
        >
          <Container width={1000} isCenter={true} $isHide={false}>
            <Container isCenter={true} $isHide={false}>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmcb">
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                  $isHide={false}
                >
                  <Col
                    width={{ type: "flex", size: "1" }}
                    style={{ marginRight: "30px" }}
                  >
                    <Title
                      height={54}
                      image=""
                      text=""
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      isTextHasIcon={true}
                      style={{ marginBottom: "20px" }}
                      textIcon="https://y2.ifengimg.com/a/2014_15/7b090fcd6711a14.jpg"
                    />
                    <NewsList_1
                      newsChip={{
                        $data: true,
                        id: "289010",
                        type: "recommend",
                        title: "新闻内容",
                        default: { type: "recommend", id: "285838" },
                        uuid: "6c9986e9",
                        force: 1661225459857,
                      }}
                      hoverColor="#ba2636"
                      titleStyle={{
                        color: "#2b2b2b",
                        fontSize: "24px",
                        lineHeight: "32px",
                        marginBottom: "9px",
                      }}
                      subTitleGroupSize={2}
                      subTitleStyle={{ fontSize: "14px", lineHeight: "26px" }}
                      nodeId="node_ocl744mcf617"
                      itemStyle={{
                        paddingBottom: "24px",
                        marginTop: "24px",
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                        borderBottomColor: "#ebebeb",
                      }}
                      isHasThumbnail={false}
                      thumbnailWidth={140}
                      thumbnailHeight={100}
                      thumbnailStyle={{ marginRight: "20px" }}
                    />
                  </Col>
                  <Col width={{ size: 323, type: "px" }}>
                    <Title
                      height={48}
                      image="https://x0.ifengimg.com/ucms/2025_42/92C71A5256575DC49D065C1452338FB7A76A5668_size26_w325_h50.jpg"
                      text="焦点图"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      isTextHasIcon={false}
                      style={{ paddingLeft: "10px" }}
                      nodeId="node_ocl744mcf618"
                      hoverStyle=""
                    />
                    <Swiper_1
                      swiperChip={{
                        $data: true,
                        id: "289011",
                        type: "recommend",
                        title: "轮播图内容",
                        default: { type: "recommend", id: "285915" },
                        uuid: "e0195eef",
                      }}
                      height={260}
                      isHasNav={false}
                      leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                      rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                      navWidth={22}
                      navHeight={40}
                      navY={290}
                      navX={15}
                      isAutoPlay={true}
                      autoSpeed={3000}
                      skin={3}
                    />
                    <Title
                      height={48}
                      image="https://x0.ifengimg.com/ucms/2025_42/92C71A5256575DC49D065C1452338FB7A76A5668_size26_w325_h50.jpg"
                      text="视频"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                        paddingLeft: "0px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      isTextHasIcon={false}
                      style={{
                        marginTop: "30px",
                        marginBottom: "0px",
                        paddingLeft: "10px",
                      }}
                      nodeId="node_ocl744mcf61a"
                      hoverStyle=""
                    />
                    <VideoList_1
                      videoChip={{
                        $data: true,
                        id: "289012",
                        type: "recommend",
                        title: "视频列表",
                        format: {
                          filter: ["title", "posterUrl", "videoPlayUrl"],
                        },
                        default: { type: "recommend", id: "285924" },
                        uuid: "bdd6aeb8",
                      }}
                      width={323}
                      height={240}
                      autoPlay={false}
                      controls={true}
                      hoverColor="#ba2636"
                      skin={0}
                      continuePlay={false}
                      listIcon="https://x2.ifengimg.com/fe/custom/xghg25/video.559ac347.png"
                      listIconWidth={14}
                      listIconHeight={9}
                      listStyle={{
                        paddingLeft: "19px",
                        paddingRight: "10px",
                        height: "48px",
                        fontSize: "14px",
                        color: "#2b2b2b",
                        lineHeight: "48px",
                      }}
                      nodeId="node_ocl744mcf61b"
                    />
                  </Col>
                </Row>
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocmh4crq962">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2025_42/59E3515026541639199794D8F9DDC45688427083_size82_w1000_h50.jpg"
                  text="开幕致辞"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p83"
                  hoverStyle=""
                />
                <NewsList_7
                  newsChip={{
                    $data: true,
                    id: "289022",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285973" },
                    uuid: "37e74356",
                  }}
                  mainArticleTitleStyle={{
                    color: "#222222",
                    fontWeight: 700,
                    fontSize: "32px",
                    lineHeight: "40px",
                    marginBottom: "30px",
                  }}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocmh4crq964">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2025_42/59E3515026541639199794D8F9DDC45688427083_size82_w1000_h50.jpg"
                  text="主旨演讲 全球合作治理·推进公正转型"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p83"
                  hoverStyle=""
                />
                <NewsList_12
                  newsChip={{
                    $data: true,
                    id: "289023",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "287410" },
                    uuid: "a02f181e",
                  }}
                  colNum={3}
                  thumbnailWidth={320}
                  thumbnailHeight={180}
                  showThumbnailHoverScale={true}
                  formatImageType={1}
                  isHasTitle={true}
                  titleRows={2}
                  titleHoverColor="#ba2636"
                  titleStyle={{
                    paddingTop: "15px",
                    color: "#2b2b2b",
                    fontSize: "18px",
                    lineHeight: "24px",
                    fontWeight: 700,
                    marginBottom: "10px",
                  }}
                  showSummary={true}
                  summaryRows={3}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocmh4i007f1">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2025_42/59E3515026541639199794D8F9DDC45688427083_size82_w1000_h50.jpg"
                  text="开幕圆桌对话：共治共行·多方推动气候行动"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p83"
                  hoverStyle=""
                />
                <NewsList_12
                  newsChip={{
                    $data: true,
                    id: "289024",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "287410" },
                    uuid: "ecd46239",
                  }}
                  colNum={3}
                  thumbnailWidth={320}
                  thumbnailHeight={180}
                  showThumbnailHoverScale={true}
                  formatImageType={1}
                  isHasTitle={true}
                  titleRows={2}
                  titleHoverColor="#ba2636"
                  titleStyle={{
                    paddingTop: "15px",
                    color: "#2b2b2b",
                    fontSize: "18px",
                    lineHeight: "24px",
                    fontWeight: 700,
                    marginBottom: "10px",
                  }}
                  showSummary={true}
                  summaryRows={3}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmcc">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2025_42/59E3515026541639199794D8F9DDC45688427083_size82_w1000_h50.jpg"
                  text="CFA协会可持续投资基础证书发布"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p83"
                  hoverStyle=""
                />
                <NewsList_7
                  newsChip={{
                    $data: true,
                    id: "289021",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285973" },
                    uuid: "e54cf7a9",
                  }}
                  mainArticleTitleStyle={{
                    color: "#222222",
                    fontWeight: 700,
                    fontSize: "32px",
                    lineHeight: "40px",
                    marginBottom: "30px",
                  }}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmcd">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2025_42/59E3515026541639199794D8F9DDC45688427083_size82_w1000_h50.jpg"
                  text="主旨演讲"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p85"
                  hoverStyle=""
                />
                <NewsList_5
                  newsChip={{
                    $data: true,
                    id: "289019",
                    type: "recommend",
                    title: "新闻内容",
                    format: {
                      filter: [
                        "thumbnails",
                        "title",
                        "type",
                        "url",
                        "base62Id",
                        "summary",
                        "children",
                        "source",
                        "position",
                      ],
                    },
                    default: { type: "recommend", id: "285908" },
                    uuid: "c763b1d5",
                  }}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmce">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2025_42/59E3515026541639199794D8F9DDC45688427083_size82_w1000_h50.jpg"
                  text="陆家嘴日报"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p88"
                  hoverStyle=""
                />
                <Swiper_finance
                  swiperChip={{
                    $data: true,
                    id: "261068",
                    type: "struct",
                    title: "轮播图内容",
                    default: { type: "struct", id: "260257" },
                    uuid: "e6ded56f",
                  }}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmcf">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2025_42/59E3515026541639199794D8F9DDC45688427083_size82_w1000_h50.jpg"
                  text="精彩视频"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p8a"
                  hoverStyle=""
                />
                <VideoList_1
                  videoChip={{
                    $data: true,
                    id: "289015",
                    type: "recommend",
                    title: "视频列表",
                    format: { filter: ["title", "posterUrl", "videoPlayUrl"] },
                    default: { type: "recommend", id: "285924" },
                    uuid: "fd91a014",
                  }}
                  width={580}
                  height={457}
                  autoPlay={false}
                  controls={true}
                  hoverColor="#ba2636"
                  skin={1}
                  continuePlay={false}
                  listIcon="https://x2.ifengimg.com/fe/custom/xghg25/video.559ac347.png"
                  listIconWidth={14}
                  listIconHeight={9}
                  listStyle={{
                    paddingLeft: "19px",
                    paddingRight: "10px",
                    height: "48px",
                    fontSize: "14px",
                    color: "#2b2b2b",
                    lineHeight: "48px",
                  }}
                  nodeId="node_ocl75lh7p8b"
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmcg">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2025_42/59E3515026541639199794D8F9DDC45688427083_size82_w1000_h50.jpg"
                  text="精彩图集"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p8c"
                  hoverStyle=""
                />
                <Swiper_1
                  swiperChip={{
                    $data: true,
                    id: "289016",
                    type: "recommend",
                    title: "轮播图内容",
                    default: { type: "recommend", id: "285915" },
                    uuid: "ffb12299",
                  }}
                  height={620}
                  isHasNav={false}
                  leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                  rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                  navWidth={22}
                  navHeight={40}
                  navY={290}
                  navX={15}
                  isAutoPlay={true}
                  autoSpeed={3000}
                  skin={0}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmch">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2025_42/59E3515026541639199794D8F9DDC45688427083_size82_w1000_h50.jpg"
                  text="议程"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p8e"
                  hoverStyle=""
                />
                <Image_Tabs
                  imagesChip={{
                    $data: true,
                    id: "261069",
                    type: "struct",
                    title: "图片信息",
                    default: { type: "struct", id: "260307" },
                    uuid: "ce1af4a3",
                  }}
                  contentHeight={800}
                />
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmci">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2025_42/59E3515026541639199794D8F9DDC45688427083_size82_w1000_h50.jpg"
                  text="相关报道"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p8f"
                  hoverStyle=""
                />
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                  $isHide={false}
                >
                  <Col width={{ type: "flex", size: "1" }}>
                    <Title
                      height={30}
                      image=""
                      text="相关报道"
                      textStyle={{
                        paddingLeft: "5px",
                        color: "#2b2b2b",
                        fontWeight: 400,
                        fontSize: "14px",
                        lineHeight: "22px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={true}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        color: " #2b2b2b",
                        marginRight: " 5px",
                      }}
                      addAfterHref="https://www.ifeng.com"
                      isTextHasIcon={false}
                      style={{
                        backgroundColor: "#eeeeee",
                        borderColor: "#dddddd",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        marginBottom: "10px",
                      }}
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "289017",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "3a3a9440",
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasTime={true}
                      titleHoverColor="#ba2636"
                      titleStyle={{ fontSize: "14px", lineHeight: "24px" }}
                      isHasDot={true}
                      dotStyle={{
                        marginRight: "6px",
                        width: "9px",
                        height: "9px",
                        backgroundColor: "#cececd",
                        borderTopLeftRadius: "100px",
                        borderTopRightRadius: "100px",
                        borderBottomLeftRadius: "100px",
                        borderBottomRightRadius: "100px",
                      }}
                      nodeId="node_ocl75lh7p81q"
                    />
                    <Title
                      height={30}
                      image=""
                      text="相关报道"
                      textStyle={{
                        paddingLeft: "5px",
                        color: "#2b2b2b",
                        fontWeight: 400,
                        fontSize: "14px",
                        lineHeight: "22px",
                      }}
                      textAlign="flex-start"
                      isHasAddonAfter={true}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        color: " #2b2b2b",
                        marginRight: " 5px",
                      }}
                      addAfterHref="https://www.ifeng.com"
                      isTextHasIcon={false}
                      style={{
                        backgroundColor: "#eeeeee",
                        borderColor: "#dddddd",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        marginBottom: "10px",
                      }}
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "289018",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "71c65fbe",
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasDot={true}
                      dotStyle={{
                        marginRight: "6px",
                        width: "9px",
                        height: "9px",
                        backgroundColor: "#cececd",
                        borderTopLeftRadius: "100px",
                        borderTopRightRadius: "100px",
                        borderBottomLeftRadius: "100px",
                        borderBottomRightRadius: "100px",
                      }}
                      titleHoverColor="#ba2636"
                      titleStyle={{ fontSize: "14px", lineHeight: "24px" }}
                      isHasTime={true}
                      nodeId="node_ocl75lh7p81s"
                    />
                  </Col>
                  <Col
                    width={{ size: 335, type: "px" }}
                    style={{ marginLeft: "20px" }}
                  >
                    <Support
                      supportChip={{
                        $data: true,
                        id: "261070",
                        type: "struct",
                        title: "赞助列表",
                        default: { type: "struct", id: "260259" },
                        uuid: "e1de7de3",
                        force: 1661225459896,
                      }}
                      rightsName="财经"
                      rightsUrl="https://finance.ifeng.com"
                    />
                  </Col>
                </Row>
              </LayoutComponent>
              <LayoutComponent isCenter={true} nodeId="node_ocl7o7awmcj">
                <Title
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2025_42/59E3515026541639199794D8F9DDC45688427083_size82_w1000_h50.jpg"
                  text="网友评论"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                  textAlign="flex-start"
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  isTextHasIcon={false}
                  style={{ marginTop: "30px", marginBottom: "10px" }}
                  nodeId="node_ocl75lh7p81w"
                  hoverStyle=""
                />
                <Comment
                  url="https://finance.ifeng.com/loc/ljz2022"
                  title="陆家嘴2022"
                />
              </LayoutComponent>
            </Container>
          </Container>
          <Footer year="2022" style={{ marginTop: "60px" }} />
        </Container>
      <ChipEdit transform={chipDataTransform} />
</div>
    );
  }
}

export default Layout$$Page;

function __$$eval(expr) {
  try {
    return expr();
  } catch (error) {}
}

function __$$evalArray(expr) {
  const res = __$$eval(expr);
  return Array.isArray(res) ? res : [];
}

function __$$createChildContext(oldContext, ext) {
  const childContext = {
    ...oldContext,
    ...ext,
  };
  childContext.__proto__ = oldContext;
  return childContext;
}
